var map = {
	"./DC.mp3": 192,
	"./DC_demo.mp3": 551,
	"./HF.mp3": 782,
	"./HF_demo.mp3": 964,
	"./Prac.mp3": 366,
	"./Prac_demo.mp3": 68,
	"./VF.mp3": 684,
	"./VF_demo.mp3": 6,
	"./direct_copy.mp3": 865,
	"./vertical_flip.mp3": 412
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 924;